import React from "react"

import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"

import { BuildingReferenceGridView } from "./ui/BuildingReferenceGridView"

export interface BuildingReferenceGridModel {
  buildingReferenceObjs: BuildingReferenceObj[]
}

export interface BuildingReferenceGridProps extends BuildingReferenceGridModel {
  emptyMessage?: string
  container?: HTMLElement | null
  priorityProducts?: string[] | null
}

export const BuildingReferenceGrid = React.memo(
  (model: BuildingReferenceGridProps) => {
    return <BuildingReferenceGridView {...model} />
  }
)
